module.exports = __webpack_public_path__ + "img/tank-dark.bc84633d.png";